// Sentry DEVE ser importado antes de qualquer outro módulo
import './sentry'
import * as Sentry from '@sentry/react'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import ErrorScreen from './components/ErrorScreen'
import { isStaleChunkError } from './utils/isStaleChunkError'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error }) =>
        isStaleChunkError(error) ? (
          <ErrorScreen
            code="•••"
            icon={RefreshCw}
            title="O sistema foi atualizado"
            message="Saiu uma versão nova enquanto essa aba estava aberta. Recarregue a página para continuar — nada foi perdido."
            actions={[
              { label: 'Recarregar a página', onClick: () => window.location.reload(), primary: true },
            ]}
          />
        ) : (
          <ErrorScreen
            code="500"
            icon={AlertTriangle}
            title="Algo deu errado"
            message="O erro foi reportado automaticamente para o time. Tente recarregar a página."
            details={error?.toString()}
            actions={[
              { label: 'Recarregar a página', onClick: () => window.location.reload(), primary: true },
              { label: 'Ir para o início', href: '/' },
            ]}
          />
        )
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
